<template>
  <a-modal
    :wrapClassName="disabeld ? 'ps-see-form-modal' : ''"
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    :ok-text="saveText"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="vintages">
          <a-date-picker
            :disabled="disabeld"
            placeholder="请选择加入年份"
            v-model="form.vintages"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
          />
        </a-form-model-item>
        <a-form-model-item label="资金来源" prop="capitalSource">
          <a-select v-model="form.capitalSource" :disabled="disabeld">
            <a-select-option
              :value="item.value"
              v-for="(item, index) in zjlylist"
              :key="index"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="资金金额" prop="amount">
          <div class="flex">
            <a-input-number
              :min="0"
              :disabled="disabeld"
              v-model="form.amount"
            />
            <span class="surplus-money">元 </span>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        name: "",
        capitalSource: "",
        amount: "",
        vintages: "",
      },
      rules: {
        vintages: [
          {
            required: true,
            message: "请选择年份",
            validator: (rule, value, callback) => {
              if (this.form.vintages != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            trigger: "change",
          },
        ],
        capitalSource: [
          {
            required: true,
            message: "请选择资金来源",
            trigger: "change",
          },
        ],
        amount: [
          {
            required: true,
            message: "请输入金额",
            trigger: "blur",
          },
        ],
      },
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      zjlylist: [],
      yearShowOne: false,
      disabeld: false,
      taskId: null,
      detailId: null,
      saveText: "保存",
      teacherdata: {},
    };
  },
  methods: {
    init(type, record, taskId, detailId) {
      this.type = type;
      this.visible = true;
      this.zjlys();
      this.disabeld = false;
      if (type == "add") {
        this.form = {};
        this.form.applyId = record.id;
        this.form.vintages = new Date().getFullYear() + "";
        this.title = "添加资金来源";
      } else if (type == "edit") {
        this.title = "编辑资金来源";
        this.form = {
          teacherName: record.teacherName,
          sex: record.sex,
          birthday: record.birthday,
          degree: record.degree,
          professionalTitle: record.professionalTitle,
          major: record.major,
          izResponse: record.izResponse,
          applyId: record.applyId,
          id: record.id,
          primaryMission: record.primaryMission,
          vintages: record.vintages,
          capitalSource: record.capitalSource,
          amount: record.amount,
        };
        this.teacherdata = record;
      } else if (type === "audit-edit") {
        this.title = "编辑资金来源";
        this.taskId = taskId;
        this.detailId = detailId;
        this.saveText = "提交";
        // 合并所有字段，确保编辑时能正确显示原有数据
        this.form = {
          teacherName: record.teacherName,
          sex: record.sex,
          birthday: record.birthday,
          degree: record.degree,
          professionalTitle: record.professionalTitle,
          major: record.major,
          primaryMission: record.primaryMission,
          izResponse: record.izResponse,
          applyId: record.applyId,
          id: record.id,
          vintages: record.vintages,
          capitalSource: record.capitalSource,
          amount: record.amount,
        };
      } else if (type == "see") {
        this.disabeld = true;
        this.title = "查看资金来源";
        this.saveText = "关闭";
        this.form = {
          teacherName: record.teacherName,
          sex: record.sex,
          birthday: record.birthday,
          degree: record.degree,
          professionalTitle: record.professionalTitle,
          major: record.major,
          primaryMission: record.primaryMission,
          izResponse: record.izResponse,
          applyId: record.applyId,
          id: record.id,
          vintages: record.vintages,
          capitalSource: record.capitalSource,
          amount: record.amount != null ? record.amount : "",
        };
      }
    },
    zjlys() {
      // this.zjlylist = [
      //   {
      //     value: "省补贴",
      //     title: "省补贴",
      //   },
      //   {
      //     value: "地方补贴",
      //     title: "地方补贴",
      //   },
      //   {
      //     value: "学校自筹",
      //     title: "学校自筹",
      //   },
      //   {
      //     value: "其他来源",
      //     title: "其他来源",
      //   },
      // ];
      getAction("/baseCommon/getDictItemsByCode?code=capital_source ", {}).then(
        (res) => {
          if (res.code == 200) {
            this.zjlylist = res.result;
          }
        }
      );
    },
    handleCancel() {
      this.visible = false;
    },
    submit() {
      if (this.disabeld) {
        this.visible = false;
        return false;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            let params = this.form;
            params.applyType = this.applyType;
            // params.applyId = "1829722136428707841";
            if (
              typeof this.form.vintages == "object" &&
              this.form.vintages != "" &&
              this.type == "add"
            ) {
              this.form.vintages =
                new Date(this.form.vintages).getFullYear() + "";
            }
            postAction("/lxBase/lxSubsidyFund/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("foundPay");
              } else {
                this.$message.error(res.message);
              }
            });
          } else if (this.type == "audit-edit") {
            let params = {
              taskId: this.taskId,
              afterJson: JSON.stringify({ ...this.form }),
              detailId: this.detailId,
            };
            postAction("/audit/lxAuditTask/reSubmitTask", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success(res.message || "编辑成功");
                  this.$emit("foundPay");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            if (
              this.teacherdata?.status == "0" ||
              this.teacherdata?.status == "1" ||
              this.teacherdata?.status == "4" ||
              this.teacherdata?.status == "3" ||
              (this.teacherdata?.status == "2" && this.teacherdata?.operation)
            ) {
              let params1 = this.form;
              params1.applyType = this.applyType;
              // params.applyId = "1829722136428707841";
              if (typeof this.form.vintages == "object") {
                params1.vintages =
                  new Date(this.form.vintages).getFullYear() + "";
              }

              let params = {
                id: this.teacherdata?.taskId,
                applicationData: JSON.stringify(this.$nullToEmpty(params1)),
              };
              if (this.teacherdata?.status == "4") {
                params.auditState = "1";
              }
              putAction("/audit/lxAuditTask/editTaskAndDetail", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("foundPay");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            } else {
              let params = this.form;
              params.applyType = this.applyType;
              // params.applyId = "1829722136428707841";
              if (typeof this.form.vintages == "object") {
                params.vintages =
                  new Date(this.form.vintages).getFullYear() + "";
              }
              putAction("/lxBase/lxSubsidyFund/edit", params).then((res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success("编辑成功");
                  this.$emit("foundPay");
                } else {
                  this.$message.error(res.message);
                }
              });
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.vintages = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    panelChangeOne(value) {
      // this.form.vintages = value;
      const year = moment(value).format("YYYY");
      this.form.vintages = year + "";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("vintages");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.surplus-money {
  width: 200px;
  display: inline-block;
  margin-left: 12px;
}
</style>
